var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonwithiconEditModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875485,
    y: 0.874997,
    width: 23.2496,
    height: 23.2496,
    rx: 2.62498,
    stroke: "#28519E",
    strokeWidth: 0.749994
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1487_9991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87549 15.7813V18.125H9.21922L16.1317 11.2126L13.7879 8.86883L6.87549 15.7813ZM17.9441 9.40008C18.1879 9.15633 18.1879 8.76258 17.9441 8.51883L16.4817 7.05635C16.2379 6.8126 15.8442 6.8126 15.6004 7.05635L14.4567 8.20009L16.8004 10.5438L17.9441 9.40008Z",
    fill: "#28519E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1487_9991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9999,
    height: 14.9999,
    fill: "white",
    transform: "translate(5.00049 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonwithiconEditModule);
export default __webpack_public_path__ + "static/media/Button with iconEditModule.cbb94b8d0f18c6831c0fe6a5512a314c.svg";
export { ForwardRef as ReactComponent };